module.exports = __webpack_public_path__ + "static/dirt-5b72648287c59eec5e6a8eac4c2e23da.png";